<template>
    <div class="body-panel">
        <div class="form-modal-body">

            <div class="row">
                <b-field style="width: 100%;" label="API Key">
                    <div class="api-key-container">
                        <b-input type="text" v-model="form.api_key" readonly disabled></b-input>
                        <b-button @click="copyApiKey" type="is-primary">Copy</b-button>
                    </div>
                </b-field>
            </div>

            <div class="nb">
                Don't share your API key with anyone.
            </div>
        </div>
        <div class="form-optional-panel">
            <b-button :loading="submit_loading" @click="updateApiKey" type="is-primary">GENERATE NEW API KEY</b-button>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    sockets: {},
    data: () => ({
        form: {
            api_key: "",
        },
        submit_loading: false,
    }),
    watch: {},
    mounted() {
        let vm = this;
        vm.getApiKey();
    },
    methods: {
        copyApiKey() {
            let vm = this;
            console.log(vm.form.api_key);
            vm.form.api_key = vm.form.api_key.trim();
            navigator.clipboard.writeText(vm.form.api_key);
            vm.$notify({
                group: "status",
                type: "success",
                title: "Success",
                text: "API key copied to clipboard",
            });
        },
        updateApiKey() {
            let vm = this;
            vm.submit_loading = true;
            vm.$store
                .dispatch("STREAMER_USER_GENERATE_CHANNEL_API_KEY", vm.form)
                .then((response) => {
                    vm.submit_loading = false;
                    vm.$emit("saved");
                    vm.$notify({
                        group: "status",
                        type: "success",
                        title: "Important message",
                        text: response.data.message,
                    });
                    vm.getApiKey();
                })
                .catch(({ response }) => {
                    vm.submit_loading = false;
                    vm.$notify({
                        group: "status",
                        type: "warn",
                        title: "OOPS!!!",
                        text: response.data.message,
                    });
                });
        },
        getApiKey() {
            let vm = this;
            vm.$store
                .dispatch("STREAMER_USER_GET_CHANNEL_API_KEY")
                .then((response) => {
                    if (response.data.return) {
                        vm.form.api_key = response.data.return;
                    } else {
                        vm.form.api_key = 'N/A';
                    }
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.body-panel {
    height: calc(100% - 55px);


    .form-modal-body {
        display: flex;
        flex-direction: column;
        height: calc(100% - 70px);
        padding: 20px;
        overflow-y: auto;

        .nb {
            font-size: 12px;
            color: #999;
            margin-top: 10px;
        }
    }


    .form-optional-panel {
        height: 70px;
        border-top: 1px solid #ddd;
        display: flex;
        align-items: center;
        padding: 0px 20px;
    }

    .api-key-container {
        display: grid;
        grid-template-columns: 1fr 100px;
        gap: 10px;
    }
}
</style>